var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEcosystemHeartHandShake(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.42 4.58C19.9183 4.07658 19.3222 3.67714 18.6658 3.40459C18.0095 3.13204 17.3057 2.99174 16.595 2.99174C15.8843 2.99174 15.1806 3.13204 14.5242 3.40459C13.8678 3.67714 13.2717 4.07658 12.77 4.58L12 5.36L11.23 4.58C10.7283 4.07658 10.1322 3.67714 9.47585 3.40459C8.81947 3.13204 8.11574 2.99174 7.40503 2.99174C6.69431 2.99174 5.99058 3.13204 5.3342 3.40459C4.67783 3.67714 4.0817 4.07658 3.58003 4.58C1.46003 6.7 1.33003 10.28 4.00003 13L12 21L20 13C22.67 10.28 22.54 6.7 20.42 4.58Z",
    stroke: "#FBD365",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.36L8.87001 8.5C8.4743 8.89894 8.25226 9.43809 8.25226 10C8.25226 10.5619 8.4743 11.1011 8.87001 11.5C9.26895 11.8957 9.8081 12.1178 10.37 12.1178C10.9319 12.1178 11.4711 11.8957 11.87 11.5L14.13 9.29C14.6917 8.73428 15.4499 8.42258 16.24 8.42258C17.0301 8.42258 17.7883 8.73428 18.35 9.29L20.75 11.69",
    stroke: "#FBD365",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15L16 13",
    stroke: "#FBD365",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18L13 16",
    stroke: "#FBD365",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcosystemHeartHandShake);
export default __webpack_public_path__ + "static/media/EcosystemHeartHandShake.13c1b9c534a3f7493cb1420b7184df65.svg";
export { ForwardRef as ReactComponent };